import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, "Helvetica", "Arial", sans-serif',
  },
});

export default theme;
